<template>
	
		<mapbase 
		:mapColor="mapColor" 
		:mapTitle="mapTitle" 
		:mapName="mapName" 
		:unit="unit" 
		:pieces="pieces"
		:cityD="cityD"
		:provicesD="provicesD"
		/>
		<!-- <mapbase /> -->
	
</template>

<script>
	import mapbase from './mapbase.vue'
	import '../../static/js/provincePipeDensity.js'
	import '../../static/js/cityPipeDensity.js'
	export default {
		
		components: {
			mapbase,
		},
		data(){
			return {
				cityD:cityPipeDensity,
				provicesD:provincePipeDensity,
				unit:'公里/平方公里',
				mapName:'城市供水管道密度',
				mapTitle:'2018年城市供水管道密度地图(公里/平方公里)',
				mapColor:['#fff', '#D6D6FF', '#9EA4E8', '#6C7DD4', '#405DBD', '#1D49A8','#003994'],
				pieces:[
							{
								min:25.0421513
							}, 
							{
								min: 16.4000001 ,
								max:25.0421512
							},
							{
								min: 11.8153562 ,
								max: 16.4000000
							},
							{
								min: 8.62435898 ,
								max: 11.8153561
							},
							{
								min: 5.37937744  ,
								max: 8.62435897
							},
							{
								min:0.163104326  ,
								max: 5.37937743
							},
							{
								min: 0,
								max: 0.163104326
							}
							
						]
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: calc(100vh - 200px);
		margin: auto;
		/* border: 2px solid aquamarine; */
	}
	
	.search{
		margin-right: 30px;
		text-align: right;
		margin-bottom: 20px;
	}
	.search .el-input{
		width:30%
	}
	@media screen and (max-width:600px) {
		.search .el-input{
			width:50%
		}
	}
</style>
